// btoa/atob only operate on latin1 strings; these helpers cover the
// byte-array and UTF-8 cases the call sites actually need.

const encoder = new TextEncoder();
const decoder = new TextDecoder();

export function encodeBase64(bytes: Uint8Array | ArrayBuffer): string {
  const view = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  // chunked so fromCharCode's argument list stays within call-stack limits
  let binary = "";
  for (let i = 0; i < view.length; i += 0x8000)
    binary += String.fromCharCode(...view.subarray(i, i + 0x8000));
  return btoa(binary);
}

// forgiving: accepts the base64url alphabet and missing padding
export function decodeBase64(str: string): Uint8Array {
  let base64 = str.replace(/-/g, "+").replace(/_/g, "/");
  while (base64.length % 4) base64 += "=";
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

export const encodeBase64Unicode = (str: string): string =>
  encodeBase64(encoder.encode(str));

export const decodeBase64Unicode = (str: string): string =>
  decoder.decode(decodeBase64(str));

/**
 * Makes a base64 encoded string URL friendly: '+' and '/' are replaced with
 * '-' and '_', and any trailing '=' padding is removed.
 */
export const toBase64Url = (base64: string): string =>
  base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
